var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMprAlt = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9.75.5-8.5 3.719 8.5 3.718 8.5-3.718z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.25 4.219v10.093l8.5 3.72 8.5-3.72V4.22m-8.5 3.718v10.093"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.25 4.576v9.736l8.05 3.72.45-10.095z"
}))));
export { SvgIconMprAlt as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-mpr-alt.svg";